import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "filter-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "filter-header-text" }, "Фильтры", -1)
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "filter-items-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "filter-item-wrapper"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "filter-label" }, "Период", -1)
const _hoisted_7 = {
  key: 1,
  class: "filter-item-wrapper"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "filter-label" }, "По отделам", -1)
const _hoisted_9 = {
  key: 2,
  class: "filter-item-wrapper"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "filter-label" }, "По должностям", -1)
const _hoisted_11 = {
  key: 3,
  class: "filter-item-wrapper"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "filter-label" }, "По сотрудникам", -1)
const _hoisted_13 = { class: "filter-act-btns" }

import cancel from '@/assets/icon/cancel-dialog.svg'
import { ArrayMap } from '@/components/UI/UDropdownFilter.vue'
import { reactive, ref, onBeforeMount, inject } from 'vue'
import { formatRange } from '@/globalFunctions'
import { eventBus } from '@/eventBus'
import { Departments, Positions, Employee, SubFilterMap } from '@/models'

export interface FilterParams {
  date: string | Array<number>;
  person: string;
  department: string;
}

export interface DatesMap {
  [key: string]: Array<number>
}

type StateKeys = 'periodIsOpen' | 'employesIsOpen' | 'departmentsIsOpen' | 'positionsIsOpen'


export default /*#__PURE__*/_defineComponent({
  __name: 'UFilters',
  props: {
  filters: {
    type: Object as () => Record<string, boolean>,
    default: null,
    required: false
  },
  settedFilters: {
    type: Object as () => SubFilterMap,
    required: false
  }
},
  emits: ['click-res', 'close', 'filter-set'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const date = ref([new Date(), new Date()])

const days: ArrayMap[] = inject('days', [])

const props = __props

const state = reactive({
  periodIsOpen: false,
  periodEl: 0,
  departmentsIsOpen: false,
  positionsIsOpen: false,
  departmentEl: -1,
  positionEl: -1,
  departmentId: '',
  positionId: '',
  employesIsOpen: false,
  employeeEl: -1,
  employeeId: '',
  datePreset: true,
  dateSwitcherInfo: 'Задать промежуток',
  departments: [] as Departments,
  positions: [] as Positions,
  departmentsDropArr: [] as ArrayMap[],
  positionsDropArr: [] as ArrayMap[],
  employes: [] as Employee[],
  employesDropArr: [] as ArrayMap[]
})

onBeforeMount(() => {
  const departmentsData = sessionStorage.getItem('departments')
  if (departmentsData) {
    state.departments = JSON.parse(departmentsData)
    state.departmentsDropArr = state.departments.map(item => ({
      text: item.name,
      value: item.id
    }))
  }
  const positionsData = sessionStorage.getItem('positions')
  if (positionsData) {
    state.positions = JSON.parse(positionsData)
    state.positionsDropArr = state.positions.map(item => ({
      text: item.name,
      value: item.id
    }))
  }
  const persons = sessionStorage.getItem('persons')
  if (persons) {
    state.employes = JSON.parse(persons)
    state.employesDropArr = state.employes.map(item => ({
      text: item.name,
      value: item.id
    }))
  }
  if (props.settedFilters) {
    // eslint-disable-next-line dot-notation
    if (props.settedFilters['date'] && props.settedFilters['date'] !== '') {
      // eslint-disable-next-line dot-notation
      state.periodEl = days.findIndex(day => day.value === props.settedFilters!['date']) + 1
    }
    // eslint-disable-next-line dot-notation
    if (props.settedFilters['person']) {
      // eslint-disable-next-line dot-notation
      state.employeeId = props.settedFilters['person'].toString()
      state.employeeEl = state.employesDropArr.findIndex(per => per.value === state.employeeId) + 1
    }
    // eslint-disable-next-line dot-notation
    if (props.settedFilters['department']) {
      // eslint-disable-next-line dot-notation
      state.departmentId = props.settedFilters['department'].toString()
      state.departmentEl = state.departmentsDropArr.findIndex(dep => dep.value === state.departmentId) + 1
    }
    // eslint-disable-next-line dot-notation
    if (props.settedFilters['position']) {
      // eslint-disable-next-line dot-notation
      state.positionId = props.settedFilters['position'].toString()
      state.positionEl = state.positionsDropArr.findIndex(pos => pos.value === state.positionId) + 1
    }
  }
})

function changeDateTypeFilter () {
  state.datePreset = !state.datePreset
  if (state.datePreset) {
    state.dateSwitcherInfo = 'Задать промежуток'
  } else {
    state.dateSwitcherInfo = 'Выбрать вручную'
  }
}

function changePeriod (period: number) {
  state.periodEl = period
}

function changeDepartment (index: number) {
  state.departmentEl = index
  if (state.departmentEl > -1) {
    state.departmentId = state.departmentsDropArr[index - 1].value.toString()
  } else {
    state.departmentId = ''
  }
}

function changePosition (index: number) {
  state.positionEl = index
  if (state.positionEl > -1) {
    state.positionId = state.positionsDropArr[index - 1].value.toString()
  } else {
    state.positionId = ''
  }
}

function changeEmployee (index: number) {
  state.employeeEl = index
  if (state.employeeEl > -1) {
    state.employeeId = state.employesDropArr[index - 1].value.toString()
  } else {
    state.employeeId = ''
  }
}

function returnResults () {
  let period
  if (state.datePreset) {
    period = state.periodEl - 1 < 0 ? '' : days[state.periodEl - 1].value
  } else {
    const seconDate = date.value[1] == null ? new Date(date.value[0].getFullYear(), date.value[0].getMonth(), date.value[0].getDate(), 23, 59, 59) : date.value[1]
    period = [date.value[0].getTime(), seconDate.getTime()]
  }
  const filterParams = {
    date: period,
    person: state.employeeId,
    department: state.departmentId,
    position: state.positionId
  }
  eventBus.emit('filter', filterParams)
  emits('filter-set', filterParams)
  emits('close')
}

function closeAllDropDowns () {
  state.periodIsOpen = false
  state.employesIsOpen = false
  state.departmentsIsOpen = false
}

function toggleDropDown (property: StateKeys) {
  const prevState = state[property]
  closeAllDropDowns()
  state[property] = !prevState
}


return (_ctx: any,_cache: any) => {
  const _component_u_dropdown_filter = _resolveComponent("u-dropdown-filter")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Transition, { name: "udialog-fade" }, {
    default: _withCtx(() => [
      true
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "filter-overlay",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (closeAllDropDowns()), ["self"]))
          }, [
            _createElementVNode("div", {
              class: "filter-pad",
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (closeAllDropDowns()), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("img", {
                  src: _unref(cancel),
                  class: "filter-cancel button-click",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
                }, null, 8, _hoisted_3)
              ]),
              _createElementVNode("div", _hoisted_4, [
                (!props.filters || props.filters.date)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _hoisted_6,
                      (state.datePreset)
                        ? (_openBlock(), _createBlock(_component_u_dropdown_filter, {
                            key: 0,
                            array: _unref(days),
                            isOpen: state.periodIsOpen,
                            selected: state.periodEl,
                            onClickEvent: _cache[1] || (_cache[1] = ($event: any) => (toggleDropDown('periodIsOpen'))),
                            onChooseRow: changePeriod
                          }, null, 8, ["array", "isOpen", "selected"]))
                        : (_openBlock(), _createBlock(_component_VueDatePicker, {
                            key: 1,
                            range: "",
                            validate: "",
                            modelValue: date.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((date).value = $event)),
                            locale: "ru",
                            "cancel-text": "Отмена",
                            "select-text": "Ок",
                            format: _unref(formatRange),
                            class: "vue-datepicker",
                            placeholder: "Выберите даты"
                          }, null, 8, ["modelValue", "format"])),
                      _createElementVNode("span", {
                        class: "filter-open-picker button-click",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeDateTypeFilter()))
                      }, _toDisplayString(state.dateSwitcherInfo), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!props.filters || props.filters.department)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _withDirectives(_createVNode(_component_u_dropdown_filter, {
                        array: state.departmentsDropArr,
                        isOpen: state.departmentsIsOpen,
                        selected: state.departmentEl,
                        onClickEvent: _cache[4] || (_cache[4] = ($event: any) => (toggleDropDown('departmentsIsOpen'))),
                        onChooseRow: changeDepartment
                      }, null, 8, ["array", "isOpen", "selected"]), [
                        [_directive_click_outside, () => state.departmentsIsOpen = false]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!props.filters || props.filters.department)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _withDirectives(_createVNode(_component_u_dropdown_filter, {
                        array: state.positionsDropArr,
                        isOpen: state.positionsIsOpen,
                        selected: state.positionEl,
                        onClickEvent: _cache[5] || (_cache[5] = ($event: any) => (toggleDropDown('positionsIsOpen'))),
                        onChooseRow: changePosition
                      }, null, 8, ["array", "isOpen", "selected"]), [
                        [_directive_click_outside, () => state.positionsIsOpen = false]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!props.filters || props.filters.employs)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _withDirectives(_createVNode(_component_u_dropdown_filter, {
                        array: state.employesDropArr,
                        isOpen: state.employesIsOpen,
                        selected: state.employeeEl,
                        onClickEvent: _cache[6] || (_cache[6] = ($event: any) => (toggleDropDown('employesIsOpen'))),
                        onChooseRow: changeEmployee
                      }, null, 8, ["array", "isOpen", "selected"]), [
                        [_directive_click_outside, () => state.employesIsOpen = false]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: "settings-action-btn button-click",
                  id: "save-btn",
                  onClick: returnResults
                }, " Применить "),
                _createElementVNode("button", {
                  class: "settings-action-btn button-click",
                  id: "cancel-btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (emits('close')))
                }, " Отменить ")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})